import { injectable } from 'inversify'
import { QuizSessionReducerPlugin } from '@/app/quiz-session/api'
import { StartPracticeSessionCommand, UpdatePracticeSessionQuestionStateCommand,
         UpdatePracticeSessionNavigationCommand,
         UpdatePracticeSessionQuestionTimesCommand } from './practice-session-commands'
import { PracticeSessionState } from './practice-session-state'
import { reduceQuizSessionQuestionStates, reduceQuizSessionNavigation,
         reduceQuizSessionQuestionTimes, initialQuizSessionQuestionStates,
         initialQuizSessionQuestionTimes } from '@/app/quiz-session/api'

@injectable()
export class PracticeSessionReducerPlugin implements QuizSessionReducerPlugin<PracticeSessionState, PracticeSessionCommand>  {

  reduce(state: PracticeSessionState, command: PracticeSessionCommand): PracticeSessionState {

    switch (command.name) {
      case 'start-practice-session': {
        const payload = command.payload
        return {
          questionIds: payload.questionIds,
          navigation: {
            questionIndex: payload.questionIndex,
            lastIndex: payload.questionIndex
          },
          questionStates: initialQuizSessionQuestionStates(payload.questionIds.length),
          questionTimes: initialQuizSessionQuestionTimes(payload.questionIds.length),
          levelBefore: payload.levelBefore
        }
      }
      case 'update-practice-session-question-state': {
        const payload = command.payload
        return {
          ...state,
          questionStates: reduceQuizSessionQuestionStates(state.questionStates, payload)
        }
      }
      case 'update-practice-session-navigation': {
        const payload = command.payload
        return {
          ...state,
          navigation: reduceQuizSessionNavigation(state.navigation, payload)
        }
      }
      case 'update-practice-session-question-times': {
        const payload = command.payload
        return {
          ...state,
          questionTimes: reduceQuizSessionQuestionTimes(state.questionTimes, payload)
        }
      }
    }
  }
}

type PracticeSessionCommand = StartPracticeSessionCommand | UpdatePracticeSessionQuestionStateCommand |
      UpdatePracticeSessionNavigationCommand | UpdatePracticeSessionQuestionTimesCommand
